import {Box, Text, Title} from '@mantine/core';
import React, {useEffect, type FC} from 'react';
import {
  type GetRecruitmentListResponse,
  useRecruitmentList,
} from '../../../../core/repositories/recruitingInfoRepository';
import {CardForPc} from '../../../recruitingInfo/components/Container/Presenter/CardForPc';
import {CardForSp} from '../../../recruitingInfo/components/Container/Presenter/CardForSp';
import {getAIGradient} from '../../usecase/getAIGradient';

type Props = {
  graduationYear?: number;
  industryCategoryID: number;
  setHasRecruitments?: (hasRecruitments: boolean) => void;
  setRecruitmentList?: (
    recruitmentList: GetRecruitmentListResponse | null,
  ) => void;
  titleStyleGradient?: boolean;
  title?: string;
};

const DEFAULT_TITLE = 'このES・体験記を見ている方におすすめの募集';

export const RecommendRecrutments: FC<Props> = ({
  graduationYear,
  industryCategoryID,
  setHasRecruitments,
  setRecruitmentList,
  titleStyleGradient = false,
  title = DEFAULT_TITLE,
}) => {
  const {data: recruitmentList} = useRecruitmentList({
    queryParams: {
      groupedJobTypeIDs: [],
      order: 'recommend',
      typeIDs: [],
      industryCategoryIDs: [industryCategoryID],
      tagIDs: [],
      gy: graduationYear,
      allgy: (graduationYear === undefined).toString(),
      page: 1,
      limit: 4,
    },
  });

  useEffect(() => {
    if (
      recruitmentList &&
      recruitmentList?.recruitments.length > 0 &&
      setHasRecruitments
    ) {
      setHasRecruitments(true);
    }
    if (setRecruitmentList) {
      setRecruitmentList(recruitmentList ?? null);
    }
  }, [recruitmentList, setHasRecruitments, setRecruitmentList]);

  if (
    industryCategoryID === 0 ||
    !recruitmentList ||
    recruitmentList?.recruitments.length === 0
  ) {
    return null;
  }

  return (
    <div>
      <Box className="w-full py-16">
        <Box
          id="recommend-recruitments"
          className="flex w-full justify-between"
        >
          <Title order={3}>
            <Text
              className="font-bold p-8"
              style={
                titleStyleGradient
                  ? {
                      background: getAIGradient(),
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }
                  : {}
              }
            >
              {title}
            </Text>
          </Title>
        </Box>
        <Box className="flex flex-col">
          {recruitmentList?.recruitments.map((recruitment) => (
            <React.Fragment key={recruitment.id}>
              <div
                key={`pc-${recruitment.id}`}
                className="hidden pc:inline-block"
              >
                <CardForPc recruitment={recruitment} className="mb-16" />
              </div>
              <div key={`sp-${recruitment.id}`} className="pc:hidden">
                <CardForSp recruitment={recruitment} className="border-t-2" />
              </div>
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </div>
  );
};
